import { LoadingScreen } from '@/components'
import { useInvitation } from '@/modules/account'
import { getInvitationPath } from '@/utils'
import { InvitationCard } from './Card'

interface InvitationContentProps {
  token: string
}

export const InvitationContent = ({ token }: InvitationContentProps) => {
  const { details, kind, error } = useInvitation()
  const accountName = details?.accountName
  const redirect = getInvitationPath({ token })

  if (['loading', 'loaded'].includes(kind)) return <LoadingScreen />

  const allProps = {
    not_found: {
      title: 'Invitation not found',
      description: 'This invitation link is invalid or has already been used.',
      actions: [{ to: '/login', label: 'Go to login' }],
    },

    expired: {
      title: 'Invitation expired',
      description: `The invitation from ${accountName} has expired. Please ask them to send a new one.`,
      actions: [{ to: '/login', label: 'Go to login' }],
    },

    prompt_login: {
      title: `Join ${accountName}`,
      description: `You've been invited to join ${accountName}. Log in or sign up to accept.`,
      actions: [
        { to: `/user-sign-up?redirect=${redirect}`, label: 'Sign up' },
        { to: `/login?redirect=${redirect}`, label: 'Log in' },
      ],
    },

    accepting: {
      title: `Joining ${accountName}...`,
      loading: true,
    },

    accepted: {
      title: "You're in!",
      description: "You've successfully joined the account.",
      actions: [{ to: '/', label: 'Go to dashboard' }],
    },

    error: {
      title: 'Something went wrong',
      description: error || 'Unexpected error',
      actions: [{ to: '/login', label: 'Go to login' }],
    },
  }

  const props =
    kind in allProps ? allProps[kind as keyof typeof allProps] : allProps.error

  return <InvitationCard {...props} />
}
